import { Box, Typography } from '@mui/material';
import Seo from '../components/Seo';

export default function TermsAndConditions() {
  return (
    <>
      <Seo
        path="/terms"
        title="Terms and Conditions"
        description="BingePlay's terms and conditions."
      />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#f4f7fb',
          py: { xs: 4, md: 7 },
          px: 2,
        }}
      >
        <Box
          sx={{
            maxWidth: 980,
            mx: 'auto',
            backgroundColor: '#fff',
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 12px 40px rgba(0,0,0,0.08)',
          }}
        >
          <Box
            sx={{
              background: 'linear-gradient(90deg, #14D8CE 0%, #ff4d4f 100%)',
              color: '#fff',
              px: { xs: 3, md: 5 },
              py: { xs: 3, md: 4 },
            }}
          >
            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: { xs: 24, md: 34 } }}>
              Terms & Conditions
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mt: 1 }}>
              Last updated: April 29, 2026
            </Typography>
          </Box>

          <Box sx={{ px: { xs: 3, md: 5 }, py: { xs: 3, md: 5 }, color: '#1f2937' }}>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              These Terms & Conditions govern your use of Funizzle websites, applications, and
              related services. By accessing or using Funizzle, you agree to these terms.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              1. Eligibility and Account
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              You must provide accurate information during registration and keep your account
              details up to date. You are responsible for maintaining account confidentiality and
              for all activities under your account.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              2. Acceptable Use
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 1 }}>
              You agree not to misuse the service, including but not limited to:
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 1 }}>
              1. Uploading harmful, illegal, or infringing content
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 1 }}>
              2. Attempting unauthorized access to systems or user accounts
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 1 }}>
              3. Interfering with platform security or performance
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              4. Using automated abuse, scraping, or fraudulent behavior
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              3. User Content and Uploads
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              You retain ownership of your content. By uploading content to Funizzle, you grant us a
              limited license to host, process, display, and distribute that content solely for
              operating and improving the service.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              4. Payments and Billing
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              Certain features may require payment. Billing operations are handled through
              third-party payment processors. You authorize applicable charges for services you
              purchase through your account.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              5. Account Suspension or Termination
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              We may suspend, restrict, or terminate access if these terms are violated, if we
              detect abuse or security risk, or if required by law. You may also request account
              deactivation subject to applicable retention/legal obligations.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              6. Intellectual Property
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              Platform design, branding, software, and related materials are protected by
              intellectual property laws. You may not copy, reverse engineer, or commercially
              exploit service components without permission.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              7. Disclaimer of Warranties
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              Services are provided on an &quot;as is&quot; and &quot;as available&quot; basis. We
              do not guarantee that the platform will be uninterrupted, error-free, or fully secure
              at all times.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              8. Limitation of Liability
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              To the maximum extent permitted by law, Funizzle is not liable for indirect,
              incidental, special, or consequential damages arising from use of the service.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              9. Privacy
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              Your use of the service is also governed by our Privacy Policy, which describes how
              data is collected, used, and protected.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              10. Changes to Terms
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', mb: 2 }}>
              We may update these Terms from time to time. Continued use of the platform after
              updates means you accept the revised terms.
            </Typography>

            <Typography sx={{ fontFamily: 'Rammetto One', fontSize: 18, mb: 1.5, mt: 2 }}>
              11. Contact
            </Typography>
            <Typography sx={{ fontFamily: 'Poppins', fontWeight: 600 }}>
              For questions about these Terms: support@funizzle.com
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
